import { SelectDropdown } from "@cadmakers-ui/core";
import React, { useEffect, useMemo, useState } from "react";
import { FormGroup, FormText, Input, Label } from "reactstrap";
import ElementSpacer from "../../../Layout/Components/ElementSpacer";

type Props = {
  selectedCategory?: string;
  onChangeCategory: (category: string) => void;
};

const OtherOption = "Others (please specify)";

const CategoryOptions = [
  "Building Elements",
  "Equipment & Vehicles",
  "Existing Conditions",
  "Logistics & Facilities",
  "Safety",
  OtherOption
];

const FeedbackFormResourceRequestCategoryInput: React.FC<Props> = props => {
  const getInitialCategory = () => {
    if (!props.selectedCategory) return CategoryOptions[0];

    if (!CategoryOptions.includes(props.selectedCategory)) {
      return OtherOption;
    }

    return props.selectedCategory;
  };

  const getInitialOtherValue = () => {
    if (!CategoryOptions.includes(props.selectedCategory ?? "")) {
      return props.selectedCategory;
    }

    return "";
  };

  const [dropdownValue, setDropdownValue] = useState(getInitialCategory());
  const [otherTextboxValue, setOtherTextboxValue] = useState(getInitialOtherValue());

  const dropdownOptions = useMemo(
    () =>
      CategoryOptions.map(o => ({
        label: o,
        value: o
      })),
    []
  );

  const selectedDropdownOption = useMemo(() => {
    return dropdownOptions.filter(o => o.value === dropdownValue)[0];
  }, [dropdownOptions, dropdownValue]);

  // this useEffect is used to communicate the true value of the "category" to the parent
  useEffect(() => {
    let value = dropdownValue;
    if (dropdownValue === OtherOption) {
      value = otherTextboxValue ?? "";
    }
    props.onChangeCategory(value);
  }, [dropdownValue, otherTextboxValue]);

  return (
    <FormGroup>
      <Label for="category">
        <ElementSpacer spacing=".25rem">Category</ElementSpacer>
      </Label>
      <SelectDropdown
        options={dropdownOptions}
        value={selectedDropdownOption}
        onChange={(v: any) => setDropdownValue(v.value)}
      />
      {dropdownValue === OtherOption && (
        <>
          <br />
          <Input
            placeholder="Please indicate the name of the category"
            rows={3}
            type="text"
            name="othername"
            value={otherTextboxValue}
            onChange={e => setOtherTextboxValue(e.target.value)}
          />
        </>
      )}

      <FormText>Where would you expect to find this resource in the Resource library?</FormText>
    </FormGroup>
  );
};

export default FeedbackFormResourceRequestCategoryInput;
